import { useContext } from "react";
import { WidgetContext, type WidgetContextType } from "./WidgetContext";

export const useWidget = (): WidgetContextType => {
  const context = useContext(WidgetContext);
  if (!context) {
    throw new Error("useWidget must be used within a WidgetProvider");
  }
  return context;
};
